import styled from 'styled-components'
import React, { useContext, useState } from 'react'
import { ListWrapper, Title, TitleHint } from './components'
import { EditorContext } from '../../../utils/contexts'
import { withEditorPageTracking } from '../../../shared/Tracking'

const FORM_TYPE_LABELS = {
  survey: 'Survey',
  poll: 'Poll',
  quiz: 'Quiz',
  lead_gen: 'Lead Generation',
  feedback: 'Feedback',
  salesforce: 'Salesforce',
  crm: 'CRM',
  blank: 'Blank',
}

const TemplateCard = styled(({ className, template, active, onClick }) => {
  const questions = template.defaults?.questions || []

  return (
    <div
      className={[className, active === template.id ? 'active' : ''].join(' ')}
      onClick={() => onClick(template)}
    >
      <h6>{template.name}</h6>
      <p>{template.description}</p>
      <span className="question-count">
        {questions.length} starting fields, fully customizable
      </span>
    </div>
  )
})`
  margin-bottom: 0.67em;
  transition: border-color 0.2s, box-shadow 0.2s;
  border: 2px solid #dcdcdc;
  border-radius: 6px;
  padding: 12px;
  cursor: pointer;

  &.active {
    border-color: #636363;
  }

  &:hover {
    border-color: #999;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.07);
  }

  h6 {
    font-size: 0.9em;
    font-weight: 700;
    color: #333;
    margin-bottom: 4px;
  }

  p {
    font-size: 0.82em;
    line-height: 1.4;
    color: #666;
    margin-bottom: 6px;
  }

  .question-count {
    font-size: 0.73em;
    color: #aaa;
    font-style: italic;
  }
`

function FormTemplatesStep({ className, onSelect }) {
  const { dispatch, settings, siteSettings } = useContext(EditorContext)
  const [active, setActive] = useState(null)
  const formType = settings?.form_type || 'survey'

  const templates = (siteSettings?.available_form_templates || []).filter(
    (template) => template.form_type === formType
  )

  const STYLE_KEYS = [
    'button_color', 'link_color', 'cta_border_radius', 'cta_border_width',
    'cta_border_color', 'text_field_border_radius', 'text_field_border_color',
    'text_field_border_width', 'background_color', 'text_color', 'cross_color',
    'question_text_color', 'question_font_family', 'question_text_size',
    'border_radius',
  ]

  const onClick = (template) => {
    setActive(template.id)
    const styleDefaults = STYLE_KEYS.reduce((acc, key) => {
      if (template.defaults?.[key] != null) acc[key] = template.defaults[key]
      return acc
    }, {})
    dispatch({
      type: 'update',
      payload: {
        form_template_id: template.id,
        form_template_name: template.id,
        form_questions: template.defaults?.questions || [],
        form_template_theme: template.form_template_theme || 'customer-feedback-survey',
        headline: template.defaults?.headline || '',
        caption: template.defaults?.caption || '',
        ...styleDefaults,
      },
    })
    onSelect(template.id)
  }

  return (
    <div className={className}>
      <Title>{FORM_TYPE_LABELS[formType] || 'Form'} Templates</Title>
      <TitleHint>
        Choose a starting point. All fields are editable on the Design page.
      </TitleHint>
      <ListWrapper>
        {templates.map((template) => (
          <TemplateCard
            key={template.id}
            template={template}
            active={active}
            onClick={onClick}
          />
        ))}
      </ListWrapper>
    </div>
  )
}

export default styled(withEditorPageTracking(FormTemplatesStep, 'FormTemplates'))``
